import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

type Props = { children: ReactNode };
type State = { error: Error | null };

/**
 * A Control-tab render throw must not unmount Flow detail (other tabs, FlowBar).
 * Surface the message so the live path can be fixed instead of a black #root.
 */
export class FlowControlTabErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('FlowControlTab crashed', error, info.componentStack);
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }
    return (
      <Box sx={{ p: 2, overflow: 'auto' }}>
        <Typography color="error" variant="subtitle1" sx={{ mb: 1 }}>
          Control view failed to render
        </Typography>
        <Typography variant="body2" component="pre" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
          {this.state.error.message}
          {this.state.error.stack ? `\n\n${this.state.error.stack}` : ''}
        </Typography>
      </Box>
    );
  }
}
